import stage from '../components/stage'
import renderer from '../components/render'
import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import Flickity from 'flickity'


class Slider extends Component {

    constructor(element) {


        super(element);
        this.element = element
        this.el = $(element)
        this.slideshow = document.getElementById('slideshow')
        this.close = document.getElementById('close-slideshow')
        this.body = document.body

        this.ref = {
            slides: null, 
            prev: null, 
            next:null
        }



    }

    mount() {

         this.resizeQue = this.resize.bind(this)
         stage.on("stage:resize", this.resizeQue);


        this.flkty = new Flickity(this.ref.slides, {
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            pauseAutoPlayOnHover: false
        });

        this.ref.prev.addEventListener('click', (e)=>{
            e.preventDefault()
            this.flkty.previous();
        })

        this.ref.next.addEventListener('click', (e) => {
            e.preventDefault()
            this.flkty.next();
        })

        this.flkty.on('staticClick', (event, pointer, cellElement, cellIndex)=>{
                 if (!cellElement) {
                     return;
                 }
                 this.slideshow.innerHTML = ""
                 this.openSlideshow(cellElement, cellElement.dataset.template)

        })

        this.close.addEventListener('click',(e)=> {
             e.preventDefault()
             this.body.classList.remove('has-slideshow')
             this.flkt.destroy()
             
        })

    }

    openSlideshow(cellElement, id) {

   
        const template = document.getElementById(id)
        const fragment = template.content.cloneNode(true)
        this.slideshow.append(fragment)
        this.body.classList.add('has-slideshow')
        gsap.delayedCall(1, this.flekt.bind(this))

    }

    flekt(){
        
         this.flkt = new Flickity('.lslider', {
             wrapAround: true,
             prevNextButtons: true,
             pageDots: false
         });
         this.flkt.resize()
    }


    resize() {
        this.flkty.resize()
       
     this.flkt && this.flkt.resize()
    }

    unmount() {

    }


}

module.exports = Slider